import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'div';
const idGen = new IDGenerator('wm_calendar');

register('wm-calendar', (): IBuildTaskDef => {
    return {
        pre: (attrs) => {
          const counter = idGen.nextUid();
          let viewType = attrs.get('view') ? attrs.get('view') + ' view' : 'month view';
          return `<${tagName} wmCalendar wmListenProperty="dataset" redrawable style="width: 100%;display: inherit; " aria-label="${viewType}"  #${counter}="wmCalendar" ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`
    };
});

export default () => {};
